import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpBackend,
  HttpClient
} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable()
export class MockApiInterceptor implements HttpInterceptor {
  private bareHttp: HttpClient;
  constructor(private handler: HttpBackend) {
    // Create a bare HttpClient that ignores other interceptors
    this.bareHttp = new HttpClient(handler);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isMockBase = environment.baseURL.startsWith('/assets/mocks');
    const targetsMock = request.url.startsWith(environment.baseURL);

    if (isMockBase && targetsMock) {
      // Always turn into a GET for static asset fetch
      const assetUrl = request.url; // keep query string; dev server will ignore for file resolution
      return this.bareHttp.get(assetUrl)
        .pipe(
          switchMap((body: any) => {
            return of(new HttpResponse({ status: 200, url: request.url, body }));
          })
        );
    }

    return next.handle(request);
  }
}